const TOGGLE_SELECTOR = '[data-broker-modal-open]';
const MODAL_SELECTOR = '[data-broker-modal]';
const CLOSE_SELECTOR = '[data-broker-modal-close]';
const BLOCK_SELECTOR = '.wp-block-ssm-brokers';

const setModalVisibility = (modal, isOpen) => {
    if (!modal) return;

    modal.classList.toggle('hidden', !isOpen);
    modal.classList.toggle('flex', isOpen);
    modal.setAttribute('aria-hidden', String(!isOpen));

    if (isOpen) {
        const dialog = modal.querySelector('[role="dialog"]');
        const closeBtn = modal.querySelector(CLOSE_SELECTOR);
        (dialog || closeBtn || modal).focus({ preventScroll: true });
    }
};

const getModalById = (block, id) => block.querySelector(`[data-broker-modal="${id}"]`);

export const setupBrokerModals = (block) => {
    const modals = block.querySelectorAll(MODAL_SELECTOR);
    const toggles = block.querySelectorAll(TOGGLE_SELECTOR);

    if (!modals.length || !toggles.length) return;

    const openModal = (id) => setModalVisibility(getModalById(block, id), true);
    const closeModal = (id) => setModalVisibility(getModalById(block, id), false);

    toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openModal(btn.dataset.brokerModalOpen);
        });
    });

    block.querySelectorAll(CLOSE_SELECTOR).forEach((btn) => {
        btn.addEventListener('click', () => closeModal(btn.dataset.brokerModalClose));
    });

    modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeModal(modal.dataset.brokerModal);
            }
        });
    });

    block.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            modals.forEach((modal) => closeModal(modal.dataset.brokerModal));
        }
    });
};

export function initBrokerModals() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
        setupBrokerModals(block);
    });
}
